<div class="p-4">
	<div class="modal-header border-0 p-0">
		<h2 class="fs-kd-button text-kd-primary" translate>Avviso</h2>
		<i class="fa-solid fa-xmark fa-lg text-kd-primary" (click)="modal.close()"></i>
	</div>
	<div class="modal-body p-0">
		<div class="confirm-delete">
			<p class="fs-kd-normal text-kd-primary" translate>{{message}}</p>
			<div class="w-100 flex-row-reverse mt-4">
				<button type="button" class="btn btn-kd-secondary btn-outline" (click)="modal.close()">{{'Chiudi' | translate}}</button>
			</div>
		</div>
	</div>
</div>
